export const firstDocumentOptions = {
  drivers_license: {
    name: '運転免許証・運転経歴証明書',
    label: ['（表面）', '（裏面）'],
    notes: [
      '運転免許証は「表」と「裏」両方の写真を1枚ずつアップロードして下さい。',
      '有効期限が過ぎている場合は更新してからアップロードして下さい。'
    ]
  },
  passport: {
    name:
    'パスポート(日本国発行のものに限る)',
    label: ['（顔写真のページ）', '（住所が記載されているページ）'],
    notes: [
      'パスポートは「顔写真のページ」と「住所が記載されているページ」両方の写真を1枚ずつアップロードして下さい。',
      'パスポートは2020年2月4日以降に発給したものは身分証明書として利用できません。',
      '有効期限が過ぎている場合は更新してからアップロードして下さい。'
    ]
  },
  residence_card: {
    name: '在留カード・特別永住者証明書',
    label: ['（表面）', '（裏面）'],
    notes: [
      '在留カードもしくは外国人登録証明書は「表面」と「裏面」両方の写真を1枚ずつアップロードして下さい。',
      '有効期限が過ぎている場合は更新してからアップロードして下さい。'
    ]
  },
  pension_book: {
    name: '国民年金手帳',
    label: ['（氏名が記載されたページ）', '（住所が記載されたページ）'],
    notes: [
      '基礎年金番号等（各種年金の記号番号も含む。）を隠したものをご提出下さい。',
      '平成9年1月以降に発行された年金手帳（青色手帳）は、住所の記載がないため受付できません。'
    ]
  },
  individual_number_card: {
    name: '個人番号カード（マイナンバーカード）',
    label: ['（表面）'],
    notes: [
      '表面のみ、アップロードをお願いします。',
      'マイナンバー通知カードの登録は、お受付することができません。'
    ]
  },
  basic_resident_register_card: {
    name: '住民基本台帳カード',
    label: ['（表面）', '（裏面）'],
    notes: [
      '住民基本台帳カードは「表」と「裏」両方の写真を1枚ずつアップロードして下さい。',
      '有効期限が過ぎている場合は更新してからアップロードして下さい。'
    ]
  },
} as const;
export const secondDocumentOptions = {
  ...firstDocumentOptions,
  public_service_receipt: {
    name: '公共料金(電気・都市ガス・水道・ＮＨＫのいずれか)の領収書',
    label: [''],
    notes: ['公共料金(電気・都市ガス・水道・ＮＨＫのいずれか)をアップロードして下さい。']
  },
  social_insurance_premium_receipt: {
    name: '社会保険料の領収書',
    label: [''],
    notes: ['社会保険料の領収書をアップロードして下さい。']
  },
  tax_certificate: {
    name: '国税・地方税の領収書または納税証明書',
    label: [''],
    notes: ['国税・地方税の領収書または納税証明書の領収書をアップロードして下さい。']
  }
} as const;
export const category1 = ['drivers_license', 'passport', 'residence_card', 'pension_book', 'individual_number_card', 'basic_resident_register_card'] as const;
export const category2 = [...category1, 'public_service_receipt', 'social_insurance_premium_receipt', 'tax_certificate'] as const;
